module.exports = __webpack_public_path__ + "fonts/dmsans-medium-webfont.9e06ee7.woff2";